module.exports = __webpack_public_path__ + "3722fc83486c507657222b410aa2b5ad.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/wei-Ruchika.png
// module id = 576
// module chunks = 30